"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "soliera": {
    "756359fd": [{
      "hkey": "64e3260b",
      "slug": "castello",
      "name": "Castello",
      "primary": true,
      "skipSearch": false
    }],
    "castello-di-sozzigalli": [{
      "hkey": "64e3260b",
      "slug": "castello",
      "name": "Castello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;